import { render } from "./index-seven-frequently.vue?vue&type=template&id=2668f6ec&scoped=true"
import script from "./index-seven-frequently.vue?vue&type=script&lang=js"
export * from "./index-seven-frequently.vue?vue&type=script&lang=js"

import "./index-seven-frequently.vue?vue&type=style&index=0&id=2668f6ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2668f6ec"]])

export default __exports__